// WelcomeSlides.jsx
import React, { useState } from 'react';
import { T } from './Translate';
import { ArrowRight, ShoppingBag, Calendar, Map, Car, Home, QrCode } from 'lucide-react';
import { Box, Button, Card, CardContent, CardMedia, Container, LinearProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { brandColors } from "../theme";
import logo13 from "../logo13.png";
const logo15 = `${process.env.PUBLIC_URL}/logo15.png`;

const WelcomeSlides = ({ onFinish }) => {
  const theme = useTheme();
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      title: <T>Bienvenido a Notiline</T>,
      description: <T>Descubre una plataforma completa que combina comercio, eventos, alojamiento y más en una sola aplicación.</T>,
      icon: null
    },
    {
      title: <T>Ofertas de Descuento</T>,
      description: <T>Encuentra las mejores ofertas con cupones exclusivos.</T>,
      icon: <ShoppingBag size={48} color={theme.palette.primary.main} />
    },
    {
      title: <T>Eventos</T>,
      description: <T>Descubre eventos importantes: inauguraciones, obras de teatro, feriados y mucho más.</T>,
      icon: <Calendar size={48} color={theme.palette.primary.main} />
    },
    {
      title: <T>Mapa con Últimas Posiciones</T>,
      description: <T>Accede al mapa con reacciones y publicaciones recientes.</T>,
      icon: <Map size={48} color={theme.palette.primary.main} />
    },
    {
      title: <T>Vehículos</T>,
      description: <T>Compra y vende vehículos nuevos y usados.</T>,
      icon: <Car size={48} color={theme.palette.primary.main} />
    },
    {
      title: <T>Alojamiento Global</T>,
      description: <T>Reserva alojamientos o alquila propiedades.</T>,
      icon: <Home size={48} color={theme.palette.primary.main} />
    },
    {
      title: <T>Pagos Seguros en USD</T>,
      description: <T>Genera y escanea códigos QR. Pagos por PayPal.</T>,
      icon: <QrCode size={48} color={theme.palette.primary.main} />
    }
  ];

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <Container maxWidth="xs">
      <CardMedia component="img" image={brandColors.mode === 'dark' ? logo13 : logo15} title="Notiline" sx={{ width: 180, mx: 'auto', mt: 4, mb: 2 }} />
      <Card sx={{ mt: 4, position: 'relative' }}>
        <LinearProgress variant="determinate" value={((currentSlide + 1) / slides.length) * 100} sx={{ position: 'absolute', top: 0, width: '100%' }} />
        <CardContent sx={{ pt: 4 }}>
          <Box sx={{ minHeight: 400, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', p: 4 }}>
            {slides[currentSlide].icon && <Box sx={{ mb: 4 }}>{slides[currentSlide].icon}</Box>}
            <Typography variant="h4" gutterBottom>{slides[currentSlide].title}</Typography>
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 600 }}>{slides[currentSlide].description}</Typography>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
            <Button onClick={prevSlide} disabled={currentSlide === 0}><T>Anterior</T></Button>
            <Box sx={{ display: 'flex', gap: 1 }}>
              {slides.map((_, index) => (
                <Box key={index} onClick={() => setCurrentSlide(index)} sx={{
                  width: 8, height: 8, borderRadius: '50%',
                  bgcolor: currentSlide === index ? 'primary.main' : 'grey.300',
                  cursor: 'pointer'
                }} />
              ))}
            </Box>
            {currentSlide === slides.length - 1 ? (
              <Button variant="contained" onClick={onFinish} endIcon={<ArrowRight size={16} />}><T>Continuar</T></Button>
            ) : (
              <Button onClick={nextSlide} endIcon={<ArrowRight size={16} />}><T>Siguiente</T></Button>
            )}
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default WelcomeSlides;
